"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureProducedByVariant = instanceOfFeatureProducedByVariant;
exports.FeatureProducedByVariantFromJSON = FeatureProducedByVariantFromJSON;
exports.FeatureProducedByVariantFromJSONTyped = FeatureProducedByVariantFromJSONTyped;
exports.FeatureProducedByVariantToJSON = FeatureProducedByVariantToJSON;
exports.FeatureProducedByVariantToJSONTyped = FeatureProducedByVariantToJSONTyped;
const feature_1 = require("./feature");
/**
 * Check if a given object implements the FeatureProducedByVariant interface.
 */
function instanceOfFeatureProducedByVariant(value) {
    if (!('feature' in value) || value['feature'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    return true;
}
function FeatureProducedByVariantFromJSON(json) {
    return FeatureProducedByVariantFromJSONTyped(json, false);
}
function FeatureProducedByVariantFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'feature': (0, feature_1.FeatureFromJSON)(json['feature']),
        'quantity': json['quantity'],
    };
}
function FeatureProducedByVariantToJSON(json) {
    return FeatureProducedByVariantToJSONTyped(json, false);
}
function FeatureProducedByVariantToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'quantity': value['quantity'],
    };
}
//# sourceMappingURL=featureProducedByVariant.js.map